import {
  Button,
  DropdownMenu,
  DropdownMenuAddon,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@aircall/ds";
import { CircleCheck, Minimize2 } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

import SentimentHappyGrey from "@/assets/images/sentiment_happy_grey.svg?react";
import SmsConversationFill from "@/assets/images/sms_conversation_fill.svg?react";

import { PLAYER_ACTION_BUTTON_SIZE } from "../Player/Player.constants";

import { TimelineModePickerProps, timelineMode } from ".";

// No size class on the trigger glyphs: the DS icon-lg token sizes them.
function PickIcon({ mode }: Pick<TimelineModePickerProps, "mode">) {
  switch (mode) {
    case timelineMode.simple:
      return <Minimize2 />;
    case timelineMode.karaoke:
      return <SmsConversationFill />;
    case timelineMode.sentiments:
      return <SentimentHappyGrey />;
    default:
      return null;
  }
}

export function TimelineModePicker({
  mode,
  onClickSimple,
  onClickKaraoke,
  onClickSentiments,
}: TimelineModePickerProps) {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger
          render={
            <DropdownMenuTrigger
              render={
                <Button
                  variant="ghost"
                  size={PLAYER_ACTION_BUTTON_SIZE}
                  data-test="time-line-mode-picker-button"
                />
              }
            />
          }
        >
          <PickIcon mode={mode} />
        </TooltipTrigger>
        <TooltipContent>{t("change_view")}</TooltipContent>
      </Tooltip>
      <DropdownMenuContent data-test="dropdown">
        <DropdownMenuGroup>
          <DropdownMenuLabel>{t("view")}</DropdownMenuLabel>
          <DropdownMenuItem
            onClick={onClickSimple}
            data-test="simple-mode-timeline-button"
          >
            <Minimize2 className="size-4 text-muted-foreground" />
            {t("simple")}
            {mode === "simple" && (
              <DropdownMenuAddon>
                <CircleCheck className="size-4 text-primary" />
              </DropdownMenuAddon>
            )}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={onClickKaraoke}
            data-test="karaoke-mode-timeline-button"
          >
            <SmsConversationFill className="size-4" />
            {t("karaoke")}
            {mode === "karaoke" && (
              <DropdownMenuAddon>
                <CircleCheck className="size-4 text-primary" />
              </DropdownMenuAddon>
            )}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={onClickSentiments}
            data-test="sentiment-mode-timeline-button"
          >
            <SentimentHappyGrey className="size-4" />
            {t("emotions")}
            {mode === "sentiments" && (
              <DropdownMenuAddon>
                <CircleCheck className="size-4 text-primary" />
              </DropdownMenuAddon>
            )}
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
